import axios from "axios";
import { api } from "./client";

function tryParseJson(x) {
  if (typeof x !== "string") return x;
  try { return JSON.parse(x); } catch { return x; }
}

function buildAuthError(status, data) {
  const parsed = tryParseJson(data);

  const e = new Error(
    parsed?.Message || parsed?.message || `Login fehlgeschlagen (HTTP ${status}).`
  );
  e.status = status;
  e.raw = parsed;

  const modelState = parsed?.ModelState || parsed?.modelState;
  if (modelState && typeof modelState === "object") {
    e.fieldErrors = modelState;

    const attemptsRaw = modelState.attempts?.[0];
    const n = Number(attemptsRaw);
    e.attempts = Number.isFinite(n) ? n : null;
  } else {
    e.fieldErrors = {};
    e.attempts = null;
  }

  return e;
}

export async function loginWithEmailPassword(email, password) {
  const payloadB64 = btoa(JSON.stringify({ Email: email, Password: password }));

  try {
    const res = await api.post(
      "/auth/api/authorization",
      JSON.stringify(payloadB64),
      {
        headers: { "Content-Type": "application/json" },
        responseType: "text",
        transformResponse: (r) => r,
      }
    );

    const token = String(res.data || "").trim();
    if (!token.includes(".")) throw new Error("No JWT returned");

    sessionStorage.setItem("access_token", token);
    return token;
  } catch (err) {
    if (axios.isAxiosError(err) && err.response) {
      throw buildAuthError(err.response.status, err.response.data);
    }
    throw new Error("Netzwerkfehler: Keine Antwort vom Server.");
  }
}


export function clearToken() {
  sessionStorage.removeItem("access_token");
}
